export const selectItemById = (state, id) => state.items.byId[id]
export const selectItemWipById = (state, id) => {
  const itemWip = state.itemsWip.byId[id]
  if (itemWip) {
    return itemWip
  }
  return selectItemById(state, id)
}
